export default __webpack_public_path__ + "static/media/img_upee_mountains.3480f931.png";